import { Alert, Button, css, Paragraph, styled } from 'canoe';
import React from 'react';

import { ContentMetadata } from '@candu-ai/content/types';
import { useRetakeSnapshotNotification } from '@candu-ai/snapshots/utils';
import { useNavigation } from 'commons/hooks';
import { contentPath } from 'dashboard/pages/Content/constants';

const NotificationContainer = styled.div`
  ${({ theme }) => css`
    max-width: 90%;
    width: 980px;
    position: fixed;
    margin: ${theme.spaces.s} auto;
    top: 35px;
    left: 0;
    right: 0;
    z-index: 124;
  `}
`;

interface Props {
  contentMetadata: ContentMetadata;
  messagePrefix?: string;
  disabled?: boolean;
}

export const RetakeSnapshotNotification = ({
  contentMetadata,
  messagePrefix = 'Not seeing your content?',
  disabled = false,
}: Props) => {
  const navigate = useNavigation();

  const { showNotification, closeNotification } = useRetakeSnapshotNotification(
    contentMetadata,
    !disabled,
  );

  if (!showNotification) {
    return null;
  }

  return (
    <NotificationContainer key="outdated-snapshot-notification-placements">
      <Alert intent="info" onClose={closeNotification}>
        <Paragraph size="short" font="smaller" maxWidth="none" noMargin>
          {messagePrefix} Try{' '}
          <Button
            appearance="text"
            inline
            size="normal"
            onClick={() => navigate(`${contentPath(contentMetadata.id)}?showPlacementsTabOnLoad`)}
          >
            going to the Placements tab
          </Button>{' '}
          to retake the Snapshot and ensure the selector you’re targeting is still a match.
        </Paragraph>
      </Alert>
    </NotificationContainer>
  );
};
